module.exports = __webpack_public_path__ + "media/images/emblems/Bois-ddAmont-blazon-3e8d825315b92c3970e13be6bf1394a8.svg";